/**
 * FullStory element labeling helpers.
 * Use data-fs-element so buttons show up as named Elements in FullStory search/analytics.
 * @see https://developer.fullstory.com/browser/fullcapture/set-element-properties/
 */

type FsElementOptions = {
  /** Stable kebab id for search, e.g. "accept-all-cookies" */
  id?: string;
  /** Page area, e.g. "header", "hero", "cookie-banner" */
  section?: string;
  /** Component kind (default "button") */
  component?: string;
};

/** Spread onto buttons/links: data-fs-element + stable data-* attrs */
export function fsElement(name: string, opts: FsElementOptions = {}) {
  const attrs: Record<string, string> = {
    "data-fs-element": name,
    "data-component": opts.component ?? "button",
  };
  if (opts.id) attrs["data-id"] = opts.id;
  if (opts.section) attrs["data-section"] = opts.section;
  return attrs;
}

/** Human-readable page name from pathname for FullStory page properties */
export function fsPageNameFromPath(pathname: string | null): string {
  if (!pathname || pathname === "/") return "Marketing Home";
  if (pathname.startsWith("/auth/login")) return "Auth Login";
  if (pathname.startsWith("/auth/signup")) return "Auth Signup";
  if (pathname.startsWith("/auth/customer")) return "Customer Auth";
  if (pathname.startsWith("/pricing")) return "Pricing";
  if (pathname.startsWith("/features")) return "Features";
  if (pathname.startsWith("/contact")) return "Contact";
  if (pathname.startsWith("/book/demo")) return "Public Demo Booking";
  if (pathname.startsWith("/demo/book")) return "Demo Business Booking";
  if (pathname.startsWith("/book/")) return "Public Booking";
  if (pathname.startsWith("/app/onboarding")) return "Owner Onboarding";
  if (pathname.startsWith("/app/")) return "Owner Dashboard";
  if (pathname.startsWith("/admin/")) return "Platform Admin";
  if (pathname.startsWith("/customer/")) return "Customer Portal";
  return pathname;
}
